import * as React from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import {
	isPaymentMethodRequiredError,
	isWriteFailedError,
	type PartnerWriteError,
} from "../types";

export interface RenderPartnerWriteErrorOptions {
	/** Callback for `PaymentMethodRequiredError` — renders a "Set payment method" action. */
	onSetPaymentMethod?: () => void;
	/** Callback for `WriteFailedError` with code `RECURLY_DECLINED` — renders an "Update payment method" action. */
	onUpdatePaymentMethod?: () => void;
}

/**
 * Renders a `PartnerWriteError` as a MUI Alert, optionally with an actionable
 * button for the two error variants that have a recovery path. Templates that
 * surface partner write errors should call this instead of rolling their own
 * branching to keep the recovery affordances consistent.
 */
export function renderPartnerWriteError(
	err: PartnerWriteError,
	options?: RenderPartnerWriteErrorOptions,
): React.ReactNode {
	if (isPaymentMethodRequiredError(err) && options?.onSetPaymentMethod) {
		return (
			<Alert
				severity="error"
				action={
					<Button
						color="inherit"
						size="small"
						onClick={options.onSetPaymentMethod}>
						Set payment method
					</Button>
				}>
				{err.userMessage}
			</Alert>
		);
	}
	if (
		isWriteFailedError(err) &&
		err.code === "RECURLY_DECLINED" &&
		options?.onUpdatePaymentMethod
	) {
		return (
			<Alert
				severity="error"
				action={
					<Button
						color="inherit"
						size="small"
						onClick={options.onUpdatePaymentMethod}>
						Update payment method
					</Button>
				}>
				{err.userMessage}
			</Alert>
		);
	}
	return <Alert severity="error">{err.userMessage}</Alert>;
}
